import http from "@/shared/axios-config/g-http-metodos";

function getInformacoesProdutoCarregamento(pedidoId){
    const { res, erro, requisicao } = http.getObj(`pedido/getInformacoesProdutoCarregamento/${pedidoId}`)
    return { ProdutoCarregamento: res, erro, requisicao };
}

function getValorSemIpi(quantidade, pedidoId){
    const { res, erro, requisicao } = http.get(`pedido/getValorSemIpi/${quantidade}/${pedidoId}`)
    return { Valor: res, erro, requisicao }
}

function getComponentesPedido(pedidoId){
    const { res, erro, requisicao } = http.get(`pedido/getComponentesPedido/${pedidoId}`)
    return { Componentes: res, erro, requisicao }
}

function getDetalhesPedidoECriticas(pedidoId){
    const { res, erro, requisicao } = http.get(`Produto/GetDadosDetalhesDoPedido/${pedidoId}`)
    return { DetalhePedido: res, erro, requisicao }
}


function postProdutoCarregamento(pedidoId, informacoesProdutoCarregamento){
    const { res, erro, requisicao } = http.post(`pedido/PostProdutoCarregamento/${pedidoId}`, informacoesProdutoCarregamento);
    return { Sucesso: res, erro, requisicao };
}

function postAmostraLote(pedidoId, amostraLote) {
    const { res, erro, requisicao } = http.post(`Pedido/PostAmostraLote/${pedidoId}`, amostraLote)
    return { Sucesso: res, erro, requisicao};
}

function GetVendasPorPeriodoByFiltro(objFiltros){
    const { res, erro, requisicao } = http.postArray("/Pedido/GetVendasPorPeriodoByFiltro",objFiltros);
    return { StatusArray: res, erro, requisicao }
}

function VendasPorPeriodoAtivas() {
    const { res, erro, requisicao } = http.get('Pedido/GetVendasPorPeriodo')
    return { ClientesArray: res , erro, requisicao }
}

function GetStatusPedidoEnum(){
    const { res, erro, requisicao } = http.getArray("Pedido/GetStatusPedidoEnum");
    return { StatusArray: res, erro, requisicao }
}

function GetSituacaoEnum(){
    const { res, erro, requisicao } = http.getArray("Pedido/GetSituacaoEnum");
    return { SituacaoArray: res, erro, requisicao }
}

function GetTipoPedido(pedidoId){
    const { res, erro, requisicao } = http.get(`GerarNovoPedido/GetTipoPedido/${pedidoId}`);
    return { SituacaoPedido: res, erro, requisicao };
}

function GetNotasFiscais(RepresentanteId, EmpresaId, objFiltros) {
    const{res, erro, requisicao} = http.postArray(`/Pedido/GetNotasFiscais/${RepresentanteId}/${EmpresaId}`, objFiltros)
    return{ NotasFiscaisArray : res , erro, requisicao}
}

function GetObservacoesPedidoAndamento(pedidoId, numeroParcela) {
    const {res, erro, requisicao} = http.get(`/Pedido/GetObservacoesPedidoAndamento/${pedidoId}/${numeroParcela}`)
    return {ObservacoesArray: res, erro, requisicao}
}

function GetDetalhesObservacoesPedidoAndamento(pedidoId, numeroParcela) {
    const {res, erro, requisicao} = http.get(`/Pedido/GetDetalhesObservacoesPedidoAndamento/${pedidoId}/${numeroParcela}`)
    return {ObservacoesDetalhesArray: res, erro, requisicao}
}

function GetPedidosAguardandoAprovacaoByFiltro(objFiltros) {
    const {res, erro, requisicao} = http.post('/Pedido/GetPedidosAguardandoAprovacaoByFiltro', objFiltros)
    return {PedidosArray: res, erro, requisicao}
}

function GetPedidosCanceladosOuLiquidadosByFiltro(filtros) {
    const { res, erro, requisicao } = http.postArray('pedido/GetPedidosCanceladosOuLiquidadosByFiltro', filtros)
    return { PedidosCanceladosLiquidadosArray: res , erro, requisicao }
}

function GetInformacaoTipoPedidoEnum() {
    const { res, erro, requisicao } = http.getArray('pedido/GetTipoPedidoEnum')
    return { TipoPedidoArray: res, erro, requisicao }
}

function GetComponentesByPedidoId(pedidoId) {
    const { res, erro, requisicao } = http.getArray(`/PedidoComponente/GetComponentesByPedidoId/${pedidoId}`)
    return { ComponentePedido: res, erro, requisicao }
}

function DeletarPedidoDigitacao(pedidoId){
    const { res, erro, requisicao } = http.post(`pedido/DeletarPedidoDigitacao/${pedidoId}`);
    return { Sucesso: res, erro, requisicao };
}

function GetPedidoConcluidoByDash(EmpresaId,RepresentanteId){
    const {res, erro, requisicao } = http.get(`Pedido/GetPedidoConcluidoByDash/${EmpresaId}/${RepresentanteId}`);
    return {Sucesso: res,erro, requisicao};
}

function GetPedidoQueryByDash(pedidoInfosDash){
    const {res, erro, requisicao } = http.post(`Pedido/GetPedidoQueryByDash/${pedidoInfosDash}`);
    return {Sucesso: res,erro, requisicao};
}


function GetPedidoRepeticao(produtoId){
    const { res, erro, requisicao } = http.getArray(`pedido/GetPedidoRepeticao/${produtoId}`)
    return { PedidoRepeticaoArray: res, erro, requisicao }
}

function GetInformacaoPedidoSituacaoEnum() {
    const { res, erro, requisicao } = http.getArray('pedido/GetPedidoSituacaoEnum')
    return { PedidoSituacaoArray: res, erro, requisicao }
}

function gerarNovoPedido(novoPedido){
    const { res, erro, requisicao } = http.post('pedido/gerarNovoPedido', novoPedido);
    return { res, erro, requisicao };
}

function GetDatasCarregamentoPedido(pedidoId){
    const { res, erro, requisicao } = http.get(`GerarNovoPedido/GetDatasCarregamentoPedido/${pedidoId}`);
    return { DataCarregamentoArray: res, erro, requisicao };
}

function GetSeloFSC(pedidoId){
    const { res, erro, requisicao } = http.get(`GerarNovoPedido/GetSeloFSC/${pedidoId}`);
    return { DataCarregamentoArray: res, erro, requisicao };
}

function GetSituacaoPedido(pedidoId){
    const { res, erro, requisicao } = http.get(`GerarNovoPedido/GetSituacaoPedido/${pedidoId}`);
    return { SituacaoPedido: res, erro, requisicao };
}

function GetClienteProgramacao(pedidoId){
    const { res, erro, requisicao } = http.get(`/GerarNovoPedido/GetClienteProgramacao/${pedidoId}`);
    return { DataCarregamentoArray: res, erro, requisicao };
}

function VerificaPedidoByOrcamentoId(orcamentoId){
    const { res, erro, requisicao } = http.get(`/GerarNovoPedido/VerificaPedidoByOrcamentoId/${orcamentoId}`);
    return { DataCarregamentoArray: res, erro, requisicao };
}

function GetOrcamentoSequencia(orcamentoId){
    const { res, erro, requisicao } = http.get(`/GerarNovoPedido/GetOrcamentoSequencia/${orcamentoId}`);
    return { SequenciaArray: res, erro, requisicao };
}

function GetAmostraLoteCheckInfos(pedidoId){
    const { res, erro, requisicao } = http.get(`Pedido/GetAmostraLoteCheckInfos/${pedidoId}`);
    return { AmostraCheckInfo: res, erro, requisicao };
}

function GetStatusPedidoParcela(){
    const { res, erro, requisicao } = http.get(`Pedido/GetStatusPedidoParcela`);
    return { StatusParcelaArray: res, erro, requisicao };
}

function GetDatasInicioEFim(pedidoId){
    const { res, erro, requisicao } = http.get(`Pedido/GetDatasInicioEFim/${pedidoId}`);
    return { Datas: res, erro, requisicao };
}

function GetPedidoDefinicaoProducao() {
    const { res, erro, requisicao } = http.getArray('pedido/GetPedidoDefinicaoProducao')
    return { PedidoSituacaoArray: res, erro, requisicao }
}

function VerificaOrcamentoSequencia(orcamentoId) {
    const { res, erro, requisicao } = http.getArray(`/GerarNovoPedido/VerificaOrcamentoSequencia/${orcamentoId}`)
    return { PedidoSituacaoArray: res, erro, requisicao }
}

function GetOrcamentoByNumeroSequencia(orcamentoInfos) {
    const { res, erro, requisicao } = http.post(`/GerarNovoPedido/GetOrcamentoByNumeroSequencia`, orcamentoInfos)
    return { PedidoSituacaoArray: res, erro, requisicao }
}



const PedidoController = {
    getInformacoesProdutoCarregamento,
    getValorSemIpi,
    getComponentesPedido,
    GetPedidoConcluidoByDash,
    postProdutoCarregamento,
    getDetalhesPedidoECriticas,
    GetVendasPorPeriodoByFiltro,
    VendasPorPeriodoAtivas,
    GetStatusPedidoEnum,
    GetSituacaoEnum,
    GetTipoPedido,
    GetNotasFiscais,
    GetStatusPedidoParcela,
    postAmostraLote,
    GetObservacoesPedidoAndamento,
    GetDetalhesObservacoesPedidoAndamento,
    GetPedidosAguardandoAprovacaoByFiltro,
    GetPedidosCanceladosOuLiquidadosByFiltro,
    GetInformacaoTipoPedidoEnum,
    GetComponentesByPedidoId,
    DeletarPedidoDigitacao,
    GetPedidoRepeticao,
    GetInformacaoPedidoSituacaoEnum,
    gerarNovoPedido,
    GetDatasCarregamentoPedido,
    GetPedidoQueryByDash,
    GetSeloFSC,
    GetSituacaoPedido,
    GetClienteProgramacao,
    VerificaPedidoByOrcamentoId,
    GetAmostraLoteCheckInfos,
    GetDatasInicioEFim,
    GetPedidoDefinicaoProducao,
    GetOrcamentoSequencia,
    VerificaOrcamentoSequencia,
    GetOrcamentoByNumeroSequencia
}

export default PedidoController;
